import Splide, { Options } from "@splidejs/splide";

export function initSplideCarousel(element: HTMLElement, options?: Options) {
  new Splide(element, options).mount();
}
